import React, { Fragment, useEffect, useState } from 'react';
// for Accordion starts
// for Accordion ends
import { SERVICE } from '@constant/types';
import { showSuccess } from '@context/actions';
import Item from '@element/horizontalItem';
import FilterModal from '@module/filterModal';
import HeadMetaTags from "@module/headMetaTags";
import ScrollingNavigation from '@module/topScrolleingNavigation';
import { filterCategory, getCurrentFilters, getItemPrice, getItemsList } from '@util/dataFilterService/itemDataService';
import { getItemMetaTags } from '@util/metaTagsService';
import { navigateTo } from '@util/routerService';
import { dynamicSort, removeObjRef } from '@util/utils';
import { windowRef } from '@util/window';
import router from 'next/router';
import ImageGallery from 'react-image-gallery';
import { useDispatch, useSelector } from 'react-redux';

import {
  BiFilterAlt
} from '@element/icons';
function AllCategoryPage({ url_Segment, storeData, activeGroup, type, metaTags }) {
    // const router = useRouter()
    const baseRouteUrl = useSelector((state: any) => state.store.baseRouteUrl);
    const [activeCategory, setActiveCategory] = useState(null);
    const [activeSubCategory, setActiveSubCategory] = useState(null);
    const [isThirdLevelCategoryAvl, setIsThirdLevelCategoryAvl] = useState(false);
    const [activeMmetaTags, setmetaTags] = useState(metaTags);
    const [accordianExpanded, setAccordianExpanded] = useState(true);
    const [showFilter, setShowFilter] = useState(false);
    const [activeFilters, setActiveFilters] = useState<any>()
    const { configData, keywords } = useSelector((state: any) => state.store ? state.store.storeData : null);
    const [filterConfig, setFilterConfig] = useState<any>();
    const [availableCategories, setAvailableCategories] = useState(storeData?.categories || []);
    const dispatch = useDispatch();
    const store = useSelector((state: any) => state);
    const activeLanguage: any = store.activeLanguage
    const languageData: any = store.languageKeywords

    useEffect(() => {
        if (availableCategories) getActiveCategory(availableCategories)
    }, [url_Segment])

    useEffect(() => {
        if (windowRef && activeCategory) window.scrollTo(0, 0);
    }, [windowRef, activeCategory])

    const scrollToList = () => {
        const element: any = document.getElementById('scroll-to-wrap');
        if (element && activeSubCategory) {
            const yOffset = -130;
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            setTimeout(() => {
                window.scrollTo({ top: y, behavior: 'smooth' });
            }, 100);
            // document.addEventListener('scroll', ((e) => {
            //     console.log("===========================")
            //     console.log("top", element.getBoundingClientRect().top)
            //     console.log("bottom", element.getBoundingClientRect().bottom)
            //     console.log("yyyy", element.getBoundingClientRect().y)
            //     console.log("window.pageYOffset", window.pageYOffset)
            //     console.log("===========================")
            // }));
        }
    }

    useEffect(() => {
        scrollToList();
    }, [activeSubCategory])

    //set initial filters list on the basis of db config 
    useEffect(() => {
        const [filterObj, filterConfigs] = getCurrentFilters(configData, type);
        if (filterConfigs && filterConfigs.active) {
            if (filterConfigs.priceRange) {
                const storeCat = JSON.parse(JSON.stringify(storeData.categories))
                const avlActiveCat = storeCat?.filter((cat) => cat.type == type);
                let allItemsList: any = [];
                avlActiveCat.map((cat: any, i: number) => {
                    allItemsList = getItemsList(allItemsList, cat);
                    if (i == avlActiveCat.length - 1 && allItemsList.length != 0) {
                        // console.log(allItemsList)
                        allItemsList.map((item: any) => {
                            let [price, salePrice] = getItemPrice(item);
                            item.billPrice = salePrice || price;
                            item.price = price;
                            item.salePrice = salePrice;
                            item.discount = salePrice ? Number((((price - salePrice) / price) * 100).toFixed(1)) : 0;
                            // console.log(item.billPrice)
                        })
                        allItemsList = allItemsList.sort(dynamicSort("billPrice", 1)); //1 == 0 1 2 3  || -1 == 3 2 1 0
                        // allItemsList.map((item: any) => {
                        //     console.log(item.billPrice)
                        // })
                        filterConfigs.maxPrice = allItemsList[allItemsList.length - 1].billPrice;
                        filterConfigs.minPrice = 0;
                        // filterConfigs.minPrice = allItemsList[0].billPrice < (filterConfigs.maxPrice / 100) ? (filterConfigs.maxPrice / 100) : allItemsList[0].billPrice;
                        setActiveFilters({ ...filterObj, minPrice: 0, maxPrice: 100 });
                        setFilterConfig({ ...filterConfigs });
                    }
                })
            } else {
                setFilterConfig({ ...filterConfigs });
                setActiveFilters({ ...filterObj });
            }
        }
    }, [configData])

    useEffect(() => {
        if (activeFilters && activeFilters.active) {
            const storeCat = JSON.parse(JSON.stringify(storeData.categories))
            const avlActiveCat = storeCat?.filter((cat) => cat.type == type);
            // console.log(activeFilters)
            avlActiveCat.map((cat: any, cati: number) => {
                if (cat.showOnUi) {
                    cat.originalItemList = cat.itemList;
                    cat = filterCategory(cat, activeFilters, filterConfig);
                }
                if (cati == avlActiveCat.length - 1) {
                    // console.log(avlActiveCat)
                    setAvailableCategories(avlActiveCat);
                    getActiveCategory(avlActiveCat)
                }
            })
        }
    }, [activeFilters, storeData])

    const getActiveCategory = (categories: any) => {
        setActiveSubCategory(null);
        setIsThirdLevelCategoryAvl(null);
        setActiveCategory(null);
        let categoryDataFromUrl = null;
        categories?.map((categoryData, categoryIndex) => {
            if (categoryData.name.toLowerCase() == url_Segment && categoryData.showOnUi) {
                categoryData.isSelected = true;
                categoryDataFromUrl = categoryData;
                setActiveCategory(categoryData);
                setmetaTags(getItemMetaTags(categoryData));
                if ((categoryData?.categoryList && categoryData?.categoryList.length != 0)) {
                    const isAnySubCatWithSubCat = categoryData.categoryList?.filter((cat) => (cat?.categoryList && cat?.categoryList.length != 0));
                    if (isAnySubCatWithSubCat?.length != 0) setIsThirdLevelCategoryAvl(true);
                    else setIsThirdLevelCategoryAvl(false)
                } else setIsThirdLevelCategoryAvl(false)
            }
            if (categoryIndex == categories?.length - 1 && !categoryDataFromUrl) {
                // active category not found by url name
                // console.log('category not found');
                const avlActiveCat = categories?.filter((cat) => cat.showOnUi && cat.type == type);
                if (avlActiveCat?.length != 0) {
                    // console.log('first category set');
                    setmetaTags(getItemMetaTags(avlActiveCat[0]));
                    setActiveCategory(avlActiveCat[0]);
                } else if (!activeFilters?.active) {
                    navigateTo('home');
                } else {
                    const avlActiveCat = categories?.filter((cat) => cat.showOnUi && cat.type == type);

                }
            }
        })
    }

    const handleSubSubCategoryClick = (category) => {
        scrollToList()
        let catUrl = category.name.toLowerCase().split(" ").join("-");
        let url = router.query.pagepath[0] + "/sub/" + catUrl;
        navigateTo(url)
        setActiveSubCategory(category);
    }

    const getPromotionalBanner = (category) => {
        if (category && category?.type == keywords[SERVICE]) {
            let imagePathsArray = [];

            if (category && category.imagePaths && category.imagePaths != null && category.imagePaths.length != 0) {
                category.imagePaths = category.imagePaths.filter((i: any) => !i.deleted)
                imagePathsArray = [...imagePathsArray, ...category.imagePaths];
            }
            if (category && (category?.categoryList && category?.categoryList.length != 0) && category.categoryList.length != 0) {
                category.categoryList?.map((catData, catIndex) => {
                    catData.imagePaths = (catData && catData.imagePaths && catData.imagePaths != null && catData.imagePaths.length != 0) ? catData.imagePaths : []
                    catData.imagePaths = catData.imagePaths.filter((i: any) => !i.deleted)
                    imagePathsArray = [...imagePathsArray, ...catData.imagePaths];
                })
            }
            if (category && category.itemList) {
                category.itemList?.map((itemData, catIndex) => {
                    if (itemData.imagePaths && itemData.imagePaths?.length != 0) {
                        itemData.imagePaths = itemData.imagePaths.filter((i: any) => !i.deleted)
                        imagePathsArray = [...imagePathsArray, ...itemData.imagePaths];
                    }
                })
            }
            if (imagePathsArray.length != 0) {
                const categoriesPromotionBannerArray = [];
                imagePathsArray?.map((imagObj) => {
                    (imagObj.active && imagObj.imagePath) && categoriesPromotionBannerArray.push({ original: imagObj.imagePath, thumbnail: imagObj.imagePath, alt: 'Promotional', bulletClass: 'slider-bullet' })
                })
                const settings = {
                    showThumbnails: false,
                    showPlayButton: false,
                    showBullets: (categoriesPromotionBannerArray && categoriesPromotionBannerArray?.length) > 1 ? true : false,
                    autoPlay: true,
                    slideDuration: configData?.storeConfig?.sparkConfig?.sliderDuration || 2000,
                    slideInterval: configData?.storeConfig?.sparkConfig?.sliderInterval || 5000,
                    startIndex: 0,
                    showNav: false,
                    showFullscreenButton: false
                }
                return <div className="promotional-banner spacing-banner " id="promotional-banner">
                    <ImageGallery items={categoriesPromotionBannerArray} {...settings} />
                </div>
            } else return null;
        } else return null;
    }

    const onSubCategoryClick = (category) => {
        // setAccordianExpanded(false);
        category.categoryList && category.categoryList?.map((cat) => {
            if (cat.name === category.name) cat.isSelected = true;
            else cat.isSelected = false;
        })
        let catUrl = category.name.toLowerCase().split(" ").join("-");
        let url = router.query.pagepath[0] + "/sub/" + catUrl
        navigateTo(url)
        setActiveSubCategory(category);
    }

    const renderItems = (itemList: any, categoryName: any, categoryId: any) => {
        if (itemList && itemList?.length != 0) {
            itemList = JSON.parse(JSON.stringify(itemList))
            return <>
                {itemList?.map((item, itemIndex) => {
                    let [price, salePrice] = getItemPrice(item);
                    item.billPrice = salePrice || price;
                    item.price = price;
                    item.salePrice = salePrice;
                    item.categoryName = categoryName;
                    item.categoryId = categoryId;
                    item.discount = salePrice ? Number((((price - salePrice) / price) * 100).toFixed(1)) : 0;
                    if (item.variations && item?.variations?.length != 0) {
                        let activeVariations = [];
                        item.variations.map((v: any) => {
                            let isValidGroup = false;
                            if (('group' in v) && v.group) {
                                isValidGroup = (v.group.toLowerCase() === 'both' || activeGroup.toLowerCase() === 'both') ? true : (v.group.toLowerCase() === activeGroup.toLowerCase());
                            } else isValidGroup = true;
                            if (isValidGroup) activeVariations.push(v);
                        })
                        item.variations = activeVariations;
                    }
                    return <React.Fragment key={Math.random()}>
                        {Boolean(item.showOnUi && !item.hideFromCatalogue) && <div className={`service-list-cover ${Object.keys(keywords).filter(function (key) { return keywords[key] === item?.type })[0]}`}>
                            <Item item={item} type={item.type} config={{ onClickAction: configData.showServicesPdp }} />
                        </div>}
                    </React.Fragment>
                })}
            </>
        } else return null;
    }

    const renderCategory = (currentCategory: any) => {
        if (currentCategory && currentCategory.showOnUi && currentCategory.active && !currentCategory.hideFromCatalogue) {
            currentCategory.categoryName = currentCategory.categoryName || currentCategory.name;
            currentCategory.categoryId = currentCategory.categoryId || currentCategory.id;
            return <div >
                {(currentCategory?.categoryList && currentCategory?.categoryList.length != 0) ? <>
                    {getPromotionalBanner(currentCategory)}
                    <div className={`services-list-wrapper clearfix ${Object.keys(keywords).filter(function (key) { return keywords[key] === currentCategory.type })[0]}-list-wrapper ${configData?.showProductInGridView ? 'grid-view' : ''}`}>
                        {currentCategory?.categoryList?.map((category, index) => {
                            category.categoryName = currentCategory.categoryName ? `${currentCategory.categoryName} - ${category.name}` : category.name;
                            category.categoryId = currentCategory.categoryId ? `${currentCategory.categoryId} - ${category.id}` : category.id;
                            return <React.Fragment key={Math.random()} >
                                {category.showOnUi && category.active && !category.hideFromCatalogue ? <div className="service-list-cover subsubcat-wrap">
                                    <div className="ser-list-title">{category.name}</div>
                                    {category?.itemList && renderItems(category?.itemList, category.categoryName, category.categoryId)}
                                </div> : null}
                            </React.Fragment>
                        })}
                    </div>
                </> :
                    <div className="fullwidth">
                        {getPromotionalBanner(currentCategory)}
                        <div className={`services-list-wrapper clearfix ${Object.keys(keywords).filter(function (key) { return keywords[key] === currentCategory.type })[0]}-list-wrapper ${configData?.showProductInGridView ? 'grid-view' : ''}`}>
                            {currentCategory?.itemList && renderItems(currentCategory?.itemList, currentCategory.categoryName, currentCategory.categoryId)}
                        </div>
                    </div>
                }
            </div>
        } else return null;
    }

    const handleFilterModalRes = (filters: any) => {
        if (filters) {
            setActiveFilters(filters);
            dispatch(showSuccess(`${languageData["Filter applied successfully"] ? languageData["Filter applied successfully"] : "Filter applied successfully"}`))
        }
        setShowFilter(false)
    }

    const getCoverImage = (category) => {
        let imagePath = "";
        if ('icon' in category) imagePath = category.icon;
        if (category.icons && category.icons.length != 0) {
            let bothImg = category.icons.filter((i: any) => i.group?.toLowerCase() === 'both');
            bothImg = bothImg.length != 0 ? bothImg[0].imagePath : '';
            if (!activeGroup || activeGroup.toLowerCase() === 'both') {
                imagePath = bothImg;
            } else {
                let grpImg = category.icons.filter((i: any) => i.group?.toLowerCase() === activeGroup.toLowerCase());
                imagePath = grpImg.length != 0 ? grpImg[0].imagePath : bothImg;
            }
        }
        // if (category.imagePaths && category.imagePaths?.length !== 0) {
        //     category.imagePaths = category.imagePaths.filter((i: any) => !i.deleted)
        // }
        // if (!category.imagePath && (category.imagePaths && category.imagePaths?.length !== 0 && category.imagePaths[0] && category.imagePaths[0].active)) {
        //     imagePath = category.imagePaths[0].imagePath;
        // }
        return imagePath
    }

    const renderItemsView = (category, isSubCat = false) => {
        if (!Boolean(category.active)) return null;

        if (isSubCat) {
            category.categoryName = `${category.categoryName} - ${category.name}`
            category.categoryId = `${category.categoryId} - ${category.id}`
        } else {
            category.categoryName = `${category.name}`
            category.categoryId = `${category.id}`
        }
        const coverImage = getCoverImage(category);
        if (!Boolean(category.active) || Boolean(category.hideFromCatalogue)) return null;

        if (isSubCat || Boolean(category.itemList?.length)) {
            let activeItems = category.itemList?.filter((i) => i.active && i.showOnUi && !i.hideFromCatalogue)
            if (!activeItems || activeItems.length == 0) return null
        }

        return <React.Fragment >
            <div className="grid-view-cat-item-list-wrap card grid-padding">
                {Boolean(category?.categoryList?.length) ? <>
                    {category.categoryList.map((subcategory, i) => {
                        const subCat = removeObjRef(subcategory);
                        subCat.categoryName = `${category.name}`;
                        subCat.categoryId = `${category.id}`;
                        return <Fragment key={i}>
                            {renderItemsView(subCat, true)}
                        </Fragment>
                    })}
                </> : <>
                    {category.type == 'service' && <div className='category-name-cover'>
                        <div className='name-cover'>
                            <div className='name'> {category.languages && category.languages[activeLanguage?.languageId]?.name ? category.languages[activeLanguage?.languageId]?.name : category?.name}</div>
                        </div>
                        {Boolean(coverImage) && <div className='category-cover-wrap'>
                            <img src={coverImage} loading="lazy" decoding="async" />
                        </div>}
                    </div>}
                    <div className={`services-list-wrapper clearfix ${Object.keys(keywords).filter(function (key) { return keywords[key] === category?.type })[0]}-list-wrapper ${configData?.showProductInGridView ? 'grid-view' : ''}`}>
                        {renderItems(category?.itemList, (category?.categoryName || category?.name), (category?.categoryId || category?.id))}
                    </div>
                </>}
            </div>
        </React.Fragment>
    }

    return (
        <>
            <HeadMetaTags title={activeMmetaTags.title} siteName={activeMmetaTags.siteName} description={activeMmetaTags.description} image={activeMmetaTags.image} storeData={storeData} />
            <div className="categorypageContainer">
                <div className='filter-nav-wrap'>
                    {filterConfig && filterConfig.active ? <>
                        <ScrollingNavigation items={availableCategories} config={{ from: 'all', type }} handleClick={(item) => setActiveCategory(item)} activeCategory={activeCategory} />
                        <div className='filter-icon-wrap'>
                            <div className='filter-icon' onClick={() => setShowFilter(true)}>
                                <BiFilterAlt />
                            </div>
                        </div>
                    </> : <>
                        <ScrollingNavigation items={availableCategories} config={{ from: 'all', type }} handleClick={(item) => setActiveCategory(item)} activeCategory={activeCategory} />
                    </>}
                </div>
                {activeCategory ? <>
                    <div className='fullwidth'>
                        {renderItemsView(activeCategory)}
                        <div className='fullwidth' id="scroll-to-wrap"></div>
                    </div>
                </> : <>
                    <div className='unavailable-data'>
                        <div className='heading'>Whoops ...</div>
                        <div className=''>We're unable to find the data that you're looking for</div>
                    </div>
                </>}
                <FilterModal
                    frompage="All-Categories"
                    filterConfig={filterConfig}
                    openModal={showFilter}
                    type={type}
                    activeFilters={activeFilters}
                    handleClose={(filters: any) => handleFilterModalRes(filters)}
                />
            </div>
        </>
    );
}

export default AllCategoryPage;
